var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("b", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("b-card-body", { staticClass: "mt-2 p-0" }, [
        !_vm.items
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "primary", label: "Loading" },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.items
          ? _c(
              "div",
              [
                _vm.itemsPerPage && typeof _vm.totalCount === "number"
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-end w-100" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c("b-pagination", {
                              attrs: {
                                size: "md",
                                disabled: _vm.loading,
                                "total-rows": _vm.totalCount,
                                "per-page": _vm.itemsPerPage,
                              },
                              model: {
                                value: _setup.currentPage,
                                callback: function ($$v) {
                                  _setup.currentPage = $$v
                                },
                                expression: "currentPage",
                              },
                            }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "mb-3 ml-3",
                              staticStyle: { width: "unset" },
                              attrs: {
                                type: "text",
                                debounce: "400",
                                placeholder: "Search",
                                disabled: _vm.loading,
                              },
                              model: {
                                value: _setup.searchString,
                                callback: function ($$v) {
                                  _setup.searchString = $$v
                                },
                                expression: "searchString",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.BTable, {
                  staticClass: "w-100 h-100 items-table",
                  attrs: {
                    "table-class": "h-100",
                    "empty-filtered-text": "No items matching your search",
                    "empty-text": "No items",
                    "show-empty": "",
                    striped: "",
                    hover: "",
                    responsive: "",
                    items: _vm.items || [],
                    fields: _vm.fields,
                    busy: _vm.loading,
                    "tbody-tr-class": _setup.getTrClass,
                    "tbody-tr-attr": _setup.getTrAttr,
                  },
                  on: { "row-clicked": _setup.onRowClicked },
                  scopedSlots: _vm._u(
                    [
                      _vm._l(_setup.slots, function (_, slotName, index) {
                        return {
                          key: slotName,
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { key: index, staticClass: "row-wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "row-content" },
                                    [_vm._t(slotName, null, null, scope)],
                                    2
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      }),
                      {
                        key: "table-busy",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "align-items-center d-flex justify-content-center my-2 text-center my-2",
                              },
                              [
                                _c("b-spinner", {
                                  attrs: { variant: "primary" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "strong",
                                  { staticClass: "ml-3 primary-text" },
                                  [_vm._v("Loading...")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "row-details",
                        fn: function (data) {
                          return [
                            _c("div", { staticClass: "row-wrapper" }, [
                              _c(
                                "div",
                                { staticClass: "row-content" },
                                [_vm._t("row-details", null, { data: data })],
                                2
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.showDoneButton
        ? _c(
            "b-btn",
            {
              staticClass: "float-right",
              attrs: { variant: "primary", disabled: !_setup.canClickDone },
              on: { click: _setup.onDone },
            },
            [_vm._v("\n        " + _vm._s(_vm.doneButtonText) + "\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }